/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CancelExperimentRunResponse,
  CreateExperimentRequest,
  CreateExperimentResponse,
  CreateExperimentRunRequest,
  ExperimentDetail,
  ExperimentRunDetail,
  ExperimentRunSnapshot,
  ExperimentShipmentReportsResponse,
  ExperimentWithState,
  RunExperimentResponse,
  ShipmentReport,
  UpdateExperimentRequest,
  UpdateExperimentRunRequest,
} from "../models/index";
import {
  CancelExperimentRunResponseFromJSON,
  CancelExperimentRunResponseToJSON,
  CreateExperimentRequestFromJSON,
  CreateExperimentRequestToJSON,
  CreateExperimentResponseFromJSON,
  CreateExperimentResponseToJSON,
  CreateExperimentRunRequestFromJSON,
  CreateExperimentRunRequestToJSON,
  ExperimentDetailFromJSON,
  ExperimentDetailToJSON,
  ExperimentRunDetailFromJSON,
  ExperimentRunDetailToJSON,
  ExperimentRunSnapshotFromJSON,
  ExperimentRunSnapshotToJSON,
  ExperimentShipmentReportsResponseFromJSON,
  ExperimentShipmentReportsResponseToJSON,
  ExperimentWithStateFromJSON,
  ExperimentWithStateToJSON,
  RunExperimentResponseFromJSON,
  RunExperimentResponseToJSON,
  ShipmentReportFromJSON,
  ShipmentReportToJSON,
  UpdateExperimentRequestFromJSON,
  UpdateExperimentRequestToJSON,
  UpdateExperimentRunRequestFromJSON,
  UpdateExperimentRunRequestToJSON,
} from "../models/index";

export interface CancelExperimentRunRequest {
  experimentRunId: string;
}

export interface CreateExperimentOperationRequest {
  createExperimentRequest: CreateExperimentRequest;
}

export interface CreateExperimentRunOperationRequest {
  experimentId: string;
  createExperimentRunRequest: CreateExperimentRunRequest;
}

export interface DeleteExperimentRequest {
  experimentId: string;
}

export interface DeleteExperimentRunRequest {
  experimentRunId: string;
}

export interface GetExperimentDetailRequest {
  experimentId: string;
}

export interface GetExperimentRunDetailRequest {
  experimentRunId: string;
}

export interface GetExperimentRunSnapshotsRequest {
  experimentId: string;
}

export interface GetExperimentRunsRequest {
  experimentId: string;
}

export interface GetExperimentShipmentReportsRequest {
  experimentId: string;
}

export interface GetFilteredExperimentShipmentReportsRequest {
  experimentId: string;
  coverageCarrierIdentifier?: string | null;
}

export interface RetryFailedQuoteGroupsRequest {
  experimentRunId: string;
  createExperimentRunRequest: CreateExperimentRunRequest;
}

export interface UpdateExperimentOperationRequest {
  experimentId: string;
  updateExperimentRequest: UpdateExperimentRequest;
}

export interface UpdateExperimentRunOperationRequest {
  experimentRunId: string;
  updateExperimentRunRequest: UpdateExperimentRunRequest;
}

/**
 *
 */
export class ExperimentsApi extends runtime.BaseAPI {
  /**
   */
  async cancelExperimentRunRaw(
    requestParameters: CancelExperimentRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CancelExperimentRunResponse>> {
    if (requestParameters["experimentRunId"] == null) {
      throw new runtime.RequiredError(
        "experimentRunId",
        'Required parameter "experimentRunId" was null or undefined when calling cancelExperimentRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentRunId"] != null) {
      queryParameters["experimentRunId"] = requestParameters["experimentRunId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/cancel-experiment-run`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CancelExperimentRunResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async cancelExperimentRun(
    requestParameters: CancelExperimentRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CancelExperimentRunResponse> {
    const response = await this.cancelExperimentRunRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async createExperimentRaw(
    requestParameters: CreateExperimentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateExperimentResponse>> {
    if (requestParameters["createExperimentRequest"] == null) {
      throw new runtime.RequiredError(
        "createExperimentRequest",
        'Required parameter "createExperimentRequest" was null or undefined when calling createExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/experiments/create-experiment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateExperimentRequestToJSON(
          requestParameters["createExperimentRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createExperiment(
    requestParameters: CreateExperimentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateExperimentResponse> {
    const response = await this.createExperimentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async createExperimentRunRaw(
    requestParameters: CreateExperimentRunOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RunExperimentResponse>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling createExperimentRun().',
      );
    }

    if (requestParameters["createExperimentRunRequest"] == null) {
      throw new runtime.RequiredError(
        "createExperimentRunRequest",
        'Required parameter "createExperimentRunRequest" was null or undefined when calling createExperimentRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/experiments/create-experiment-run`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateExperimentRunRequestToJSON(
          requestParameters["createExperimentRunRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RunExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createExperimentRun(
    requestParameters: CreateExperimentRunOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RunExperimentResponse> {
    const response = await this.createExperimentRunRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteExperimentRaw(
    requestParameters: DeleteExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RunExperimentResponse>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling deleteExperiment().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/delete-experiment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RunExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async deleteExperiment(
    requestParameters: DeleteExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RunExperimentResponse> {
    const response = await this.deleteExperimentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteExperimentRunRaw(
    requestParameters: DeleteExperimentRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RunExperimentResponse>> {
    if (requestParameters["experimentRunId"] == null) {
      throw new runtime.RequiredError(
        "experimentRunId",
        'Required parameter "experimentRunId" was null or undefined when calling deleteExperimentRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentRunId"] != null) {
      queryParameters["experimentRunId"] = requestParameters["experimentRunId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/delete-experiment-run`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RunExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async deleteExperimentRun(
    requestParameters: DeleteExperimentRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RunExperimentResponse> {
    const response = await this.deleteExperimentRunRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getExperimentDetailRaw(
    requestParameters: GetExperimentDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ExperimentDetail>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling getExperimentDetail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/get-experiment-detail`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExperimentDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getExperimentDetail(
    requestParameters: GetExperimentDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ExperimentDetail> {
    const response = await this.getExperimentDetailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getExperimentRunDetailRaw(
    requestParameters: GetExperimentRunDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ExperimentRunDetail>> {
    if (requestParameters["experimentRunId"] == null) {
      throw new runtime.RequiredError(
        "experimentRunId",
        'Required parameter "experimentRunId" was null or undefined when calling getExperimentRunDetail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentRunId"] != null) {
      queryParameters["experimentRunId"] = requestParameters["experimentRunId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/get-experiment-run-detail`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExperimentRunDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getExperimentRunDetail(
    requestParameters: GetExperimentRunDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ExperimentRunDetail> {
    const response = await this.getExperimentRunDetailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getExperimentRunSnapshotsRaw(
    requestParameters: GetExperimentRunSnapshotsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ExperimentRunSnapshot>>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling getExperimentRunSnapshots().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/get-experiment-run-snapshots`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ExperimentRunSnapshotFromJSON),
    );
  }

  /**
   */
  async getExperimentRunSnapshots(
    requestParameters: GetExperimentRunSnapshotsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ExperimentRunSnapshot>> {
    const response = await this.getExperimentRunSnapshotsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getExperimentRunsRaw(
    requestParameters: GetExperimentRunsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ExperimentRunDetail>>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling getExperimentRuns().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/get-experiment-runs`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ExperimentRunDetailFromJSON),
    );
  }

  /**
   */
  async getExperimentRuns(
    requestParameters: GetExperimentRunsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ExperimentRunDetail>> {
    const response = await this.getExperimentRunsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getExperimentShipmentReportsRaw(
    requestParameters: GetExperimentShipmentReportsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: ShipmentReport }>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling getExperimentShipmentReports().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/get-experiment-shipment-reports`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      runtime.mapValues(jsonValue, ShipmentReportFromJSON),
    );
  }

  /**
   */
  async getExperimentShipmentReports(
    requestParameters: GetExperimentShipmentReportsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: ShipmentReport }> {
    const response = await this.getExperimentShipmentReportsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getFilteredExperimentShipmentReportsRaw(
    requestParameters: GetFilteredExperimentShipmentReportsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ExperimentShipmentReportsResponse>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling getFilteredExperimentShipmentReports().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    if (requestParameters["coverageCarrierIdentifier"] != null) {
      queryParameters["coverageCarrierIdentifier"] =
        requestParameters["coverageCarrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/get-filtered-experiment-shipment-reports`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExperimentShipmentReportsResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getFilteredExperimentShipmentReports(
    requestParameters: GetFilteredExperimentShipmentReportsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ExperimentShipmentReportsResponse> {
    const response = await this.getFilteredExperimentShipmentReportsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listExperimentsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ExperimentWithState>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/experiments/list-experiments`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ExperimentWithStateFromJSON),
    );
  }

  /**
   */
  async listExperiments(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ExperimentWithState>> {
    const response = await this.listExperimentsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async retryFailedQuoteGroupsRaw(
    requestParameters: RetryFailedQuoteGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RunExperimentResponse>> {
    if (requestParameters["experimentRunId"] == null) {
      throw new runtime.RequiredError(
        "experimentRunId",
        'Required parameter "experimentRunId" was null or undefined when calling retryFailedQuoteGroups().',
      );
    }

    if (requestParameters["createExperimentRunRequest"] == null) {
      throw new runtime.RequiredError(
        "createExperimentRunRequest",
        'Required parameter "createExperimentRunRequest" was null or undefined when calling retryFailedQuoteGroups().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentRunId"] != null) {
      queryParameters["experimentRunId"] = requestParameters["experimentRunId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/experiments/retry-failed-quote-groups`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateExperimentRunRequestToJSON(
          requestParameters["createExperimentRunRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RunExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async retryFailedQuoteGroups(
    requestParameters: RetryFailedQuoteGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RunExperimentResponse> {
    const response = await this.retryFailedQuoteGroupsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateExperimentRaw(
    requestParameters: UpdateExperimentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RunExperimentResponse>> {
    if (requestParameters["experimentId"] == null) {
      throw new runtime.RequiredError(
        "experimentId",
        'Required parameter "experimentId" was null or undefined when calling updateExperiment().',
      );
    }

    if (requestParameters["updateExperimentRequest"] == null) {
      throw new runtime.RequiredError(
        "updateExperimentRequest",
        'Required parameter "updateExperimentRequest" was null or undefined when calling updateExperiment().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentId"] != null) {
      queryParameters["experimentId"] = requestParameters["experimentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/experiments/update-experiment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateExperimentRequestToJSON(
          requestParameters["updateExperimentRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RunExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async updateExperiment(
    requestParameters: UpdateExperimentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RunExperimentResponse> {
    const response = await this.updateExperimentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateExperimentRunRaw(
    requestParameters: UpdateExperimentRunOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RunExperimentResponse>> {
    if (requestParameters["experimentRunId"] == null) {
      throw new runtime.RequiredError(
        "experimentRunId",
        'Required parameter "experimentRunId" was null or undefined when calling updateExperimentRun().',
      );
    }

    if (requestParameters["updateExperimentRunRequest"] == null) {
      throw new runtime.RequiredError(
        "updateExperimentRunRequest",
        'Required parameter "updateExperimentRunRequest" was null or undefined when calling updateExperimentRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["experimentRunId"] != null) {
      queryParameters["experimentRunId"] = requestParameters["experimentRunId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/experiments/update-experiment-run`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateExperimentRunRequestToJSON(
          requestParameters["updateExperimentRunRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RunExperimentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async updateExperimentRun(
    requestParameters: UpdateExperimentRunOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RunExperimentResponse> {
    const response = await this.updateExperimentRunRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
